<template>
    <div class="coupons-container">
        <div class="status">
            <div class="line"></div>
            <div class="status-desc">当前等级{{ level }}</div>
            <div class="line"></div>
        </div>
        <div class="history">
            <div class="desc">近一年已领（{{ percent.a }}/{{ percent.b }}）</div>
            <div class="link-coupon-list" @click="gocoupons()">查看优惠券</div>
        </div>
        <div v-if="percent.a !== percent.b">
            <div class="list-container">
                <div class="list" v-for="(item, index) in couponsList" :key="index">
                    <div class="title">提前还清免息券 {{ item.title }}</div>
                    <div class="desc">有效期 {{ item.effectiveDays }}天</div>
                    <div class="btn" @click="awardCoupon">领券</div>
                </div>
            </div>
        </div>

        <div class="list-empty" v-if="percent.a >= percent.b">
            <div class="bg"></div>
            <div class="bottom-tips">您已领完当前所有可领优惠券</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'coupons',
    props: {
        level: {
            type: String,
            default: ''
        },
        percent: {
            type: Object,
            default: {}
        },
        couponsList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {};
    },
    created() {},
    methods: {
        awardCoupon() {
            this.$emit('awardCoupon');
        },
        gocoupons() {
            this.$emit('gocoupons');
        }
    }
};
</script>
<style lang="less" scoped>
@import '~@common/style/common.less';
.coupons-container {
    margin-top: 21px;
    width: 339px;
    height: 100%;
    overflow: hidden;
    margin-left: 18px;
    margin-right: 18px;
    .status {
        display: flex;
        align-content: center;
        align-items: center;
        flex-direction: row;
        justify-content: center;
        .line {
            background-color: #e3ba8a;
            width: 20px;
            height: 2px;
            display: inline-block;
            margin-left: 10px;
            margin-right: 10px;
        }
        .status-desc {
            display: inline-block;
            .f-16-bold();
            color: rgba(41, 39, 56, 1);
            line-height: 18px;
        }
    }
    .history {
        margin-top: 13px;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        .desc {
            color: #a4a7b3;
            .f-13-bold();
        }
        .link-coupon-list {
            margin-left: 20px;
            color: #c99459;
            .f-13-bold();
        }
    }
    .list-container {
        margin-top: -4px;
        .list {
            width: 339px;
            height: 80px;
            background: rgba(251, 240, 221, 1);
            border-radius: 4px;
            margin: auto;
            margin-top: 14px;
            position: relative;
            .btn {
                .f-14-bold();
                color: rgba(255, 255, 255, 1);
                line-height: 31px;
                width: 83px;
                height: 29px;
                text-align: center;
                background: linear-gradient(
                    270deg,
                    rgba(222, 169, 111, 1) 0%,
                    rgba(197, 144, 84, 1) 100%
                );
                border-radius: 18px;
                position: absolute;
                top: 26px;
                right: 21px;
            }
            .title {
                position: absolute;
                top: 20px;
                left: 30px;
                width: 112px;
                height: 18px;
                .f-16-bold();
                color: rgba(131, 84, 42, 1);
                line-height: 21px;
            }
            .desc {
                position: absolute;
                top: 46px;
                left: 30px;
                .f-12();
                color: rgba(192, 174, 147, 1);
                line-height: 16px;
            }
        }
    }

    .list-empty {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .bg {
            .backgroundImage(138px, 100px, '~@assets/img/list_empty.png');
        }
        .bottom-tips {
            margin-top: 20px;
            .f-13-bold();
            color: rgba(164, 167, 179, 1);
            line-height: 16px;
            margin-bottom: 8px;
        }
    }
}
</style>
